import { render, staticRenderFns } from "./MailConfirmed.vue?vue&type=template&id=37f8619c&scoped=true"
import script from "./MailConfirmed.vue?vue&type=script&lang=js"
export * from "./MailConfirmed.vue?vue&type=script&lang=js"
import style0 from "./MailConfirmed.vue?vue&type=style&index=0&id=37f8619c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f8619c",
  null
  
)

export default component.exports